/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrSafariToolbarSpace from 'client/components/SrSafariToolbarSpace';

import './SrUtilitySetupAmenitiesDiscountModal.less';

const SrUtilitySetupAmenitiesDiscountModal = ({ utilityPartner, onClose }) => {
  return (
    <SrModalV2
      showCloseButton={false}
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
      onClose={onClose}
      contentPadding="0px 11px"
      contentMaxWidth="555px"
    >
      <div styleName="faqTitleBox">
        <span styleName="faqTitle">
          Exclusive Discount
        </span>
      </div>
      <div styleName="cardBox">
        <div styleName="titleBox">
          <span>Why do tenants get this discount?</span>
        </div>
        <p>
          {utilityPartner.name} has enrolled all properties in an exclusive internet discount program. By partnering with popular internet providers, we offer tenants substantial savings on high-speed plans.
          <br />
          No catch—providers simply want more customers, and you benefit with lower prices and faster internet!
          Enjoy your exclusive discount today.
        </p>
      </div>
      <div styleName="cardBox">
        <div styleName="titleBox">
          <span>Which internet companies participate?</span>
        </div>
        <p>
          Almost all internet providers participate in this program because they're eager to compete and attract new customers. If you see a plan labeled as a "Best Deal," that means the internet company is part of this exclusive discount program.
        </p>
      </div>
      <div styleName="cardBox lastChild">
        <div styleName="titleBox">
          <span>Will the price ever increase?</span>
        </div>
        <p>
          Yes, the price goes up $1-3 per year. That’s still an amazing discount.
        </p>
      </div>
      <div styleName="buttonContent">
        <div styleName="buttonBox">
          <SrButton onClick={onClose} theme={SR_BUTTON_THEME_ADOBE_GREY}>
            Close
          </SrButton>
        </div>
      </div>
      <SrSafariToolbarSpace />
    </SrModalV2>
  );
};

SrUtilitySetupAmenitiesDiscountModal.propTypes = {
  utilityPartner: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilitySetupAmenitiesDiscountModal.displayName = 'SrUtilitySetupAmenitiesDiscountModal';

export default SrUtilitySetupAmenitiesDiscountModal;
